import { render, staticRenderFns } from "./stock-order-detail.vue?vue&type=template&id=f0071148&scoped=true&"
import script from "./stock-order-detail.vue?vue&type=script&lang=js&"
export * from "./stock-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./stock-order-detail.vue?vue&type=style&index=0&id=f0071148&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0071148",
  null
  
)

export default component.exports